import { FC } from 'react';

import { SWrapper } from './style';

const View: FC<any> = ({ children }) => {
  return <SWrapper>{children}</SWrapper>;
};

export default View;
